<template>
  <div class="block-palette">
    <!-- Tabs -->
    <div class="palette-tabs">
      <button
        class="tab-btn"
        :class="{ 'active': activeTab === 'blocks' }"
        @click="activeTab = 'blocks'"
      >
        <i class="bx bx-layer"></i>
        Blocos
      </button>
      <button
        class="tab-btn"
        :class="{ 'active': activeTab === 'presets' }"
        @click="activeTab = 'presets'"
      >
        <i class="bx bx-file"></i>
        Modelos
      </button>
    </div>

    <!-- Blocks Tab -->
    <div v-if="activeTab === 'blocks'" class="palette-content">
      <!-- Block Types -->
      <div class="field-category">
        <div class="category-header expanded">
          <div class="category-info">
            <i class="bx bx-cube" style="color: #556ee6;"></i>
            <span>Blocos de Conteúdo</span>
          </div>
        </div>

        <div class="category-fields">
          <div
            v-for="bt in blockTypes"
            :key="bt.type"
            class="field-item"
            draggable="true"
            @dragstart="onDragStart($event, bt)"
            @click="$emit('add-block', bt.type)"
          >
            <div class="field-icon" :style="{ background: bt.bgColor }">
              <i :class="bt.icon" :style="{ color: bt.iconColor }"></i>
            </div>
            <div class="field-info">
              <span class="field-name">{{ bt.label }}</span>
              <span class="field-type-desc">{{ bt.description }}</span>
            </div>
            <button class="btn-add" title="Adicionar bloco">
              <i class="bx bx-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Merge Tags Reference -->
      <div class="field-category">
        <div
          class="category-header"
          :class="{ 'expanded': showMergeTags }"
          @click="showMergeTags = !showMergeTags"
        >
          <div class="category-info">
            <i class="bx bx-code-curly" style="color: #7c3aed;"></i>
            <span>Merge Tags</span>
          </div>
          <div class="category-meta">
            <i class="bx bx-chevron-down expand-icon"></i>
          </div>
        </div>

        <div v-show="showMergeTags" class="category-fields">
          <div class="merge-tags-hint">
            Selecione um bloco de texto e use o painel à direita para inserir tags.
          </div>

          <div class="merge-tag-group">
            <div class="merge-tag-group-title">Participante</div>
            <div v-for="tag in participantTags" :key="tag.var" class="merge-tag-ref">
              <code>{{ tag.var }}</code>
              <span>{{ tag.label }}</span>
            </div>
          </div>

          <div class="merge-tag-group">
            <div class="merge-tag-group-title">Evento</div>
            <div v-for="tag in eventTags" :key="tag.var" class="merge-tag-ref">
              <code>{{ tag.var }}</code>
              <span>{{ tag.label }}</span>
            </div>
          </div>

          <div class="merge-tag-group">
            <div class="merge-tag-group-title">Aéreo</div>
            <div v-for="tag in flightTags" :key="tag.var" class="merge-tag-ref">
              <code>{{ tag.var }}</code>
              <span>{{ tag.label }}</span>
            </div>
          </div>

          <div class="merge-tag-group">
            <div class="merge-tag-group-title">Hospedagem</div>
            <div v-for="tag in accommodationTags" :key="tag.var" class="merge-tag-ref">
              <code>{{ tag.var }}</code>
              <span>{{ tag.label }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Presets Tab -->
    <div v-if="activeTab === 'presets'" class="palette-content">
      <div class="presets-section">
        <p class="presets-desc">
          Escolha um modelo pronto para iniciar seu documento. Os blocos serão pré-preenchidos com a estrutura padrão.
        </p>

        <div class="preset-card" @click="$emit('load-preset', 'viagem-completa')">
          <div class="preset-icon" style="background: #e0f2f1;">
            <i class="bx bx-package" style="color: #00695c;"></i>
          </div>
          <div class="preset-info">
            <strong>Viagem Completa</strong>
            <span>Aéreo + hospedagem automáticos, contatos</span>
          </div>
        </div>

        <div class="preset-card" @click="$emit('load-preset', 'viagem')">
          <div class="preset-icon" style="background: #e3f2fd;">
            <i class="bx bx-plane-take-off" style="color: #1565c0;"></i>
          </div>
          <div class="preset-info">
            <strong>Carta Pax Viagem</strong>
            <span>Aeroporto, voos, hospedagem, contatos</span>
          </div>
        </div>

        <div class="preset-card" @click="$emit('load-preset', 'voucher')">
          <div class="preset-icon" style="background: #fce4ec;">
            <i class="bx bx-receipt" style="color: #c62828;"></i>
          </div>
          <div class="preset-info">
            <strong>Carta Voucher Evento</strong>
            <span>Local, aéreo, hospedagem, contatos</span>
          </div>
        </div>

        <div class="preset-card" @click="$emit('load-preset', 'empty')">
          <div class="preset-icon" style="background: #f5f5f5;">
            <i class="bx bx-file-blank" style="color: #9e9e9e;"></i>
          </div>
          <div class="preset-info">
            <strong>Em Branco</strong>
            <span>Começar do zero</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockPalette',
  data: function () {
    return {
      activeTab: 'blocks',
      showMergeTags: false,
      blockTypes: [
        { type: 'text', label: 'Texto Rico', description: 'Parágrafos, listas, formatação', icon: 'bx bx-text', bgColor: '#f0f4ff', iconColor: '#556ee6' },
        { type: 'heading', label: 'Título de Seção', description: 'Cabeçalho destacado', icon: 'bx bx-heading', bgColor: '#fef3e2', iconColor: '#e67e22' },
        { type: 'flight-table', label: 'Tabela de Voos', description: 'Automática ou genérica', icon: 'bx bx-table', bgColor: '#f3e5f5', iconColor: '#7b1fa2' },
        { type: 'accommodation', label: 'Hospedagem', description: 'Hotel, quarto, check-in/out', icon: 'bx bx-bed', bgColor: '#e8f5e9', iconColor: '#2e7d32' },
        { type: 'divider', label: 'Separador', description: 'Linha divisória', icon: 'bx bx-minus', bgColor: '#f5f5f5', iconColor: '#616161' }
      ],
      participantTags: [
        { var: '{$nome}', label: 'Nome' },
        { var: '{$email}', label: 'Email' },
        { var: '{$cpf}', label: 'CPF' },
        { var: '{$phone}', label: 'Telefone' },
        { var: '{$grupo}', label: 'Grupo' },
        { var: '{$status_nome}', label: 'Status' }
      ],
      eventTags: [
        { var: '{$evento}', label: 'Nome do Evento' },
        { var: '{$data_atual}', label: 'Data Atual' }
      ],
      flightTags: [
        { var: '{$localizador}', label: 'Localizador' },
        { var: '{$eticket}', label: 'E-Ticket' },
        { var: '{$aereo_tabela}', label: 'Tabela de voos (HTML)' }
      ],
      accommodationTags: [
        { var: '{$hotel}', label: 'Nome do hotel' },
        { var: '{$hotel_endereco}', label: 'Endereço do hotel' },
        { var: '{$hotel_checkin}', label: 'Check-in' },
        { var: '{$hotel_checkout}', label: 'Check-out' },
        { var: '{$quarto_tipo}', label: 'Tipo de quarto' },
        { var: '{$acompanhantes_quarto}', label: 'Acompanhantes de quarto' },
        { var: '{$hospedagem_tabela}', label: 'Tabela de hospedagem (HTML)' }
      ]
    }
  },
  methods: {
    onDragStart: function (event, blockType) {
      event.dataTransfer.setData('block-type', JSON.stringify(blockType))
      event.dataTransfer.effectAllowed = 'copy'
    }
  }
}
</script>

<style scoped>
.block-palette {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.palette-tabs {
  display: flex;
  padding: 8px 8px 0;
  gap: 4px;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
}

.tab-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s;
}

.tab-btn:hover { color: #495057; }
.tab-btn.active {
  color: #556ee6;
  border-bottom-color: #556ee6;
}

.palette-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  scrollbar-width: thin;
  scrollbar-color: #d0d5dd transparent;
}

.field-category { margin-bottom: 8px; }

.category-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #f8f9fa;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.category-header:hover { background: #f0f2f5; }

.category-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #344054;
}

.category-info i { font-size: 18px; }

.category-meta {
  display: flex;
  align-items: center;
  gap: 6px;
}

.expand-icon {
  font-size: 18px;
  color: #adb5bd;
  transition: transform 0.2s;
}

.category-header.expanded .expand-icon {
  transform: rotate(180deg);
}

.category-fields { padding: 6px 0; }

.field-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 6px;
  cursor: pointer;
  transition: all 0.15s;
}

.field-item:hover {
  border-color: #556ee6;
  background: #f8f9ff;
  box-shadow: 0 2px 4px rgba(85, 110, 230, 0.1);
}

.field-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-shrink: 0;
}

.field-icon i { font-size: 16px; }

.field-info { flex: 1; min-width: 0; }

.field-name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #344054;
}

.field-type-desc {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-top: 1px;
}

.btn-add {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #556ee6;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 0.15s;
}

.field-item:hover .btn-add { opacity: 1; }

.merge-tags-hint {
  font-size: 11px;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 8px;
  line-height: 1.4;
}

.merge-tag-group { margin-bottom: 10px; }

.merge-tag-group-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #8d92a9;
  padding: 4px 8px;
}

.merge-tag-ref {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  font-size: 12px;
}

.merge-tag-ref code {
  background: #f0f4ff;
  color: #556ee6;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 600;
}

.merge-tag-ref span { color: #6c757d; }

.presets-section { padding: 4px; }

.presets-desc {
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
  margin-bottom: 12px;
}

.preset-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.15s;
}

.preset-card:hover {
  border-color: #556ee6;
  background: #f8f9ff;
  box-shadow: 0 2px 4px rgba(85, 110, 230, 0.1);
}

.preset-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-shrink: 0;
}

.preset-icon i { font-size: 20px; }

.preset-info { flex: 1; }

.preset-info strong {
  display: block;
  font-size: 13px;
  color: #344054;
}

.preset-info span {
  display: block;
  font-size: 11px;
  color: #6c757d;
  margin-top: 2px;
}
</style>
